import { useState, useEffect } from 'react';

import { useHeaderSlice } from '../../../store/slices/header/selectors';

type DelayOptions = { skipDelay?: boolean; delay?: number };

//current animation timing is 300ms so took it as default, can be passed as value if animation is changed
export const useDelayedRouteByLevel = (delayOptions?: DelayOptions): string | undefined => {
  const { skipDelay = false, delay = 300 } = delayOptions ?? {};
  const routeByLevel = useHeaderSlice.getNavRouteByLevel(2);
  const [delayedRoute, setDelayedRoute] = useState(routeByLevel);

  useEffect(() => {
    if (routeByLevel || skipDelay) {
      setDelayedRoute(routeByLevel);
    } else {
      const timeout = window.setTimeout(() => {
        setDelayedRoute(undefined);
      }, delay);
      return (): void => window.clearTimeout(timeout);
    }
  }, [delay, routeByLevel, skipDelay]);

  return delayedRoute;
};
